import { LineChart, X } from "lucide-react"
import { cn } from "@/lib/utils"

export interface ChartContextChipProps {
  label: string
  /** Opens the review/edit dialog — makes the chip body a button. */
  onClick?: () => void
  onRemove?: () => void
  className?: string
}

/**
 * Compact chip representing a chart context attached to a chat message.
 * Rendered on the composer (clickable + removable) and inside sent user
 * bubbles (static).
 */
export function ChartContextChip({ label, onClick, onRemove, className }: ChartContextChipProps) {
  const body = (
    <>
      <LineChart size={11} className="shrink-0 text-primary" />
      <span className="truncate max-w-[180px]">{label}</span>
    </>
  )

  return (
    <span
      className={cn(
        "ai-capture-chip text-foreground inline-flex items-center gap-1.5 text-caption rounded-md px-2 py-1",
        className,
      )}
    >
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          aria-label="View chart context"
          title="View & edit what will be sent to the AI"
          className="inline-flex items-center gap-1.5 min-w-0 cursor-pointer hover:opacity-80"
        >
          {body}
        </button>
      ) : (
        body
      )}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Remove attachment"
          className="text-muted-foreground hover:text-foreground cursor-pointer"
        >
          <X size={10} className="shrink-0" />
        </button>
      )}
    </span>
  )
}
